import React from 'react'
import cn from 'classnames'
import useResponsive from '@hooks/useResponsive'

function RequiredCounter({ options, count, mode, showOnMobile }) {
  const isResponsive = useResponsive(1137) || mode === 'mobile'

  return (showOnMobile && isResponsive) || (!showOnMobile && !isResponsive) ? (
    <div
      className={cn('flex start ui-multiple-selection__required-counter', {
        'is-responsive': isResponsive
      })}
    >
      <span className='text primary bold'>
        {options.filter(({ active }) => active).length}
      </span>
      <span className='ui-multiple-selection__slash-text'>{` / `}</span>
      {count} Required
    </div>
  ) : null
}

export default RequiredCounter
